var BaseView = require('./access');
var FacebookImagesView = require('./images');

module.exports = BaseView.extend({
  apiCall: 'load/albums/facebook',

  initialize: function (options) {
    this.pageId = options.pageId;
    _.bindAll(this, 'thumbnailClickEvent');
    BaseView.prototype.initialize.call(this);
  },

  initDataLoading: function () {
    this.end && this.end();
    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));
    this.initAuthenticatedDataLoading();
  },

  getParams: function () {
    var params = { page_ids: '["' + this.pageId + '"]' };
    params['fb_token'] = this.tool.facebookToken || FB.getAccessToken();

    return params;
  },

  thumbnailClickEvent: function (id) {
    this.openNewView('images', FacebookImagesView, { albumId: id });
  },

  closeView: function () {
    var hasSubViews = _.size(this.views) > 0;
    if (!hasSubViews) return true;

    BaseView.prototype.closeView.call(this);
    return false;
  }
});
